<p *cxFeature="'a11yRequiredAsterisks'" class="form-legend">
  {{ formLegendTranslation! | cxTranslate }}
</p>
